//import { NullTemplateVisitor } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular'

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private msalSrv: MsalService,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let ret = false;
    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this.msalSrv.instance.getActiveAccount() == null) {
      ret = false;
      this.router.navigate["/access-denied"];
    } 
    else
     {
      const isAdmin = localStorage.getItem("IsAdmin") ? localStorage.getItem("IsAdmin") : false;
      if (isAdmin)
        ret = true;
      else {
        ret = true;
      }
    }
    return ret;
  }


  getIsRouteAuthorized(role): boolean {
  
    return false;
  }


}
